module.exports = __webpack_public_path__ + "static/media/msl_black_4-3.3de18e5a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/products/msl_black_4-3.jpg
// module id = 74
// module chunks = 0